/* eslint-disable camelcase */
import {
  FETCH_ALL_CUSTOMER_APPOINTMENT_SUCCESS,
  CANCEL_CUSTOMER_APPOINTMENT_SUCCESS,
} from "../constants/ActionTypes";
import moment from "moment";

const initialState = {
  pastAppointment: [],
  upcomingAppointment: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ALL_CUSTOMER_APPOINTMENT_SUCCESS: {
      const {
        Appointments,
      } = payload;
      const pastAppointment = Appointments.filter(item => moment().isAfter(moment(item.from)));
      const upcomingAppointment = Appointments.filter(item => moment().isBefore(moment(item.from)));
      return {
        ...state,
        pastAppointment,
        upcomingAppointment,
      };
    }
    
    case CANCEL_CUSTOMER_APPOINTMENT_SUCCESS: {
      const index = state.upcomingAppointment.findIndex(item => item._id == payload._id);
      const upcomingAppointment = [...state.upcomingAppointment];
      upcomingAppointment.splice(index, 1, payload);
      return {
        ...state,
        upcomingAppointment: upcomingAppointment,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/CustomerAppointment.js